import React from 'react';
import { servicesData } from '../data/mock';
import { Building2, Home, FileText, CheckCircle, Scale } from 'lucide-react';

const ServiceIcon = ({ index }) => {
  const icons = [Building2, Home, FileText, Scale];
  const Icon = icons[index] || FileText;
  return <Icon size={32} className="text-[#3b82f6]" />;
};

const ServiceCard = ({ service, index, isReversed }) => {
  return (
    <div 
      className={`flex flex-col lg:flex-row ${isReversed ? 'lg:flex-row-reverse' : ''} bg-white border border-[#e2e8f0] overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-[#3b82f6]/30 rounded-lg`}
    >
      {/* Image Section */}
      <div className="w-full lg:w-1/2 min-h-[20rem] lg:min-h-[28rem] relative">
        <img 
          src={service.image} 
          alt={service.title}
          className="w-full h-full object-cover absolute inset-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a]/30 to-transparent" />
      </div>

      {/* Content Section */}
      <div className="w-full lg:w-1/2 p-10 lg:p-12 flex flex-col justify-center">
        <div className="mb-6">
          <ServiceIcon index={index} />
        </div>
        
        <h3 
          className="text-[#0f172a] font-black uppercase leading-[0.9] mb-6"
          style={{ 
            fontFamily: "'Inter', Arial, sans-serif",
            fontSize: 'clamp(1.75rem, 2rem + 0.5vw, 2.5rem)'
          }}
        >
          {service.title}
        </h3>
        
        <p className="text-[#475569] text-base font-medium leading-relaxed mb-8">
          {service.description}
        </p>

        {/* Features List */}
        <ul className="space-y-3">
          {service.features.map((feature, idx) => (
            <li key={idx} className="flex items-center gap-3 text-[#475569]">
              <CheckCircle size={18} className="text-[#3b82f6] flex-shrink-0" />
              <span className="font-medium text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const ServicesSection = () => {
  return (
    <section id="services" className="bg-white py-24 lg:py-32">
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Section Header */}
        <div className="mb-16 lg:mb-20">
          {/* Attorney Badge */}
          <div className="inline-flex items-center gap-2 bg-[#3b82f6]/10 border border-[#3b82f6]/30 rounded-full px-4 py-2 mb-6">
            <Scale size={16} className="text-[#3b82f6]" />
            <span className="text-[#3b82f6] text-sm font-semibold uppercase tracking-wide">
              For Attorneys Only
            </span>
          </div>
          
          <h2 
            className="text-[#0f172a] font-black uppercase leading-[0.85]"
            style={{ 
              fontFamily: "'Inter', Arial, sans-serif",
              fontSize: 'clamp(2.5rem, 4rem + 1vw, 5rem)'
            }}
          >
            Our Services
          </h2>
          <p className="text-[#64748b] text-lg mt-4 max-w-2xl">
            Professional paralegal support tailored exclusively for attorneys and law firms handling real estate matters.
          </p>
        </div>

        {/* Services Cards */}
        <div className="space-y-8">
          {servicesData.map((service, index) => (
            <ServiceCard 
              key={service.id} 
              service={service} 
              index={index}
              isReversed={index % 2 !== 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
